import { PackingMethodService, RackService, ZoneService } from '@gtpl/shared-services/masters';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { FGStockService } from '@gtpl/shared-services/warehouse-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { RackPositionController } from './rack-position.controller';
import { RackPosition } from './rack-position.entity';
import { RackPositionService } from './rack-position.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([RackPosition]),
  ],
  controllers: [RackPositionController],
  providers: [RackPositionService,ApplicationExceptionHandler,PackingMethodService,SaleOrderService,FGStockService,ZoneService,RackService,LogsService]
})
export class RackPositionModule {}
